import { createContext, useContext, useState, useMemo, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [toast, setToast] = useState({ open: false, msg: '', severity: 'success' });

  const showToast = useCallback((msg, severity = 'success') => {
    setToast({ open: true, msg, severity });
  }, []);

  const closeToast = useCallback(() => setToast((t) => ({ ...t, open: false })), []);

  const value = useMemo(() => ({ showToast }), [showToast]);

  return (
    <UIContext.Provider value={value}>
      {children}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={closeToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={closeToast} severity={toast.severity} variant="filled" sx={{ fontWeight: 600 }}>
          {toast.msg}
        </Alert>
      </Snackbar>
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error('useUI must be used within UIProvider');
  return ctx;
};
